import { canv } from "@/canv/global.js";
import { reverseTransformPoint } from "@/canv/utils.js";
import { saveTextToClipboard } from "@/canvasController/helpers";

export class textWidgetLinkWindow {
    constructor() {}

    show(symbolData, startData, endData, textWidget) {
        if (this.isOpened) return;

        this.symbolData = symbolData;
        this.startData = startData;
        this.endData = endData;
        this.textWidget = textWidget;

        var textWidgetLinkWindow = document.createElement("div");
        document.body.prepend(textWidgetLinkWindow);

        textWidgetLinkWindow.classList.add("textWidgetLinkWindow");
        textWidgetLinkWindow.classList.add("textWidgetLinkWindowGhost");
        textWidgetLinkWindow.classList.add("dragThrowAble");
        textWidgetLinkWindow.innerHTML = this.getBar();

        this.isOpened = true;

        this.locate();
        this.init();

        this.rerequestRepeater();
        this.requestGhost();
        canv.redraw();
    }

    hide() {
        if (!this.isOpened) return;

        clearTimeout(this.repTimer);
        clearTimeout(this.ghostTimer);

        var textWidgetLinkWindow = document.getElementsByClassName(
            "textWidgetLinkWindow",
        )[0];

        if (textWidgetLinkWindow != undefined) {
            textWidgetLinkWindow.outerHTML = "";
        }

        this.isOpened = false;
        canv.redraw(); // чтобы сразу после закрытия какой-нибудь textWidget мог открыть это меню
    }

    init() {
        const textWidgetLinkWindow = document.getElementsByClassName(
            "textWidgetLinkWindow",
        )[0];
        textWidgetLinkWindow.addEventListener(
            "mousemove",
            this.moveEvent.bind(this),
            false,
        );

        const textWidgetLinkWindowCopy = document.getElementsByClassName(
            "textWidgetLinkWindowCopy",
        )[0];
        textWidgetLinkWindowCopy.addEventListener(
            "mousedown",
            this.copyLink.bind(this),
            false,
        );
    }

    locate() {
        if (!this.isOpened) return;

        const xTarget =
            this.symbolData["symbol"].startX + this.symbolData["symbol"].width / 2;
        const yTarget = this.textWidget.lines[this.symbolData["line"]].startY; // + canv.actionManager.getZoomConstant(5)

        const menu = document.getElementsByClassName("textWidgetLinkWindow")[0];

        if (menu == undefined) return;

        var pt = reverseTransformPoint(xTarget * canv.m[0], yTarget * canv.m[0]);

        const menuSize = menu.getBoundingClientRect();
        const centerX = pt.x;
        const topY = pt.y;

        var wantedX = centerX - menuSize.width / 2;
        if (wantedX < 10) wantedX = 10;
        if (
            wantedX + menuSize.width + 10 >
            canv.canvas.getBoundingClientRect().width
        )
            wantedX = canv.canvas.getBoundingClientRect().width - menuSize.width - 10;
        menu.style.left = wantedX.toString() + "px";

        var gap = 0;
        var wantedY = topY + gap;
        if (wantedY < 60) wantedY = 60;
        if (
            wantedY + menuSize.height + 10 >
            canv.canvas.getBoundingClientRect().height
        )
            wantedY =
                canv.canvas.getBoundingClientRect().height - menuSize.height - 10;
        menu.style.top = wantedY.toString() + "px";
    }

    repeater() {
        const linkWordData = this.textWidget.linkWordGet();

        this.rerequestRepeater();

        if (this.isMouseOverMenu()) {
            return;
        }

        if (linkWordData["linkSymbolData"] == null) {
            this.hide();
        }
    }

    rerequestRepeater() {
        clearTimeout(this.repTimer);
        this.repTimer = setTimeout(this.repeater.bind(this), 300);
    }

    // ghost

    requestGhost() {
        clearTimeout(this.ghostTimer);
        this.ghostTimer = setTimeout(this.ghostAction.bind(this), 700);
    }

    ghostAction() {
        var textWidgetLinkWindow = document.getElementsByClassName(
            "textWidgetLinkWindow",
        )[0];

        if (textWidgetLinkWindow != undefined) {
            textWidgetLinkWindow.classList.remove("textWidgetLinkWindowGhost");

            // еще раз locate относительно нового символа, иначе мы покажем всплывашку под первым символом на который наведем курсор,
            // даже если при ghostAction курсорс будет находиться над другим символов. Визуально это выглядит так, что плашка появляется не в нужном месте по координате X.
            // этот if можно убрать.
            const linkWordData = this.textWidget.linkWordGet();
            if (
                linkWordData["linkSymbolData"] != null &&
                this.isEqual(
                    linkWordData["startData"],
                    linkWordData["endData"],
                    linkWordData["linkSymbolData"],
                    this.textWidget,
                )
            ) {
                this.symbolData = linkWordData["linkSymbolData"];
                this.locate();
            }
        }
    }

    // Tools

    isEqual(startData, endData, linkSymbolData, textWidget) {
        if (this.textWidget != textWidget) {
            return false;
        }

        if (this.symbolData["line"] != linkSymbolData["line"]) {
            return false;
        }

        if (
            this.startData["line"] != startData["line"] ||
            this.endData["line"] != endData["line"]
        ) {
            return false;
        }

        if (
            this.startData["position"] != startData["position"] ||
            this.endData["position"] != endData["position"]
        ) {
            return false;
        }

        return true;
    }

    moveEvent(evt) {
        canv.actionManager.lastX = evt.pageX;
        canv.actionManager.lastY = evt.pageY;
    }

    isMouseOverMenu() {
        const menu = document.getElementsByClassName("textWidgetLinkWindow")[0];

        if (menu == undefined) return false;

        if (menu.classList.contains("textWidgetLinkWindowGhost")) return false;

        const mouseX = canv.actionManager.lastX;
        const mouseY = canv.actionManager.lastY;

        const menuSize = menu.getBoundingClientRect();

        if (
            mouseX >= menuSize.x &&
            mouseX <= menuSize.x + menuSize.width &&
            mouseY >= menuSize.y &&
            mouseY <= menuSize.y + menuSize.height
        ) {
            return true;
        }

        return false;
    }

    getLinkView() {
        let link = this.symbolData.symbol?.link;
        if (typeof link !== "string") return;

        // тут важен порядок, чтоб постараться убрать максимальный вариант с www
        const prefixes = ["https://www.", "http://www.", "https://", "http://"];
        for (const prefix of prefixes) {
            if (link.startsWith(prefix)) {
                link = link.slice(prefix.length);
                break;
            }
        }

        return link;
    }

    // actions

    copyLink() {
        saveTextToClipboard(this.symbolData["symbol"].link);
        canv.appInterface.infoWindow.open("Скопировано");
    }

    // templates

    getBar() {
        return (
            `
            <div class="textWidgetLinkWindowArrow"></div>
            <div class="textWidgetLinkWindowBody">
                <a href="` +
            this.symbolData["symbol"].link +
            `" target="_blank">
                    <div class="textWidgetLinkWindowLink">
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g id="Interface / Link">
                        <path id="Vector" d="M9.1718 14.8288L14.8287 9.17192M7.05086 11.293L5.63664 12.7072C4.07455 14.2693 4.07409 16.8022 5.63619 18.3643C7.19829 19.9264 9.7317 19.9259 11.2938 18.3638L12.7065 16.9498M11.2929 7.05L12.7071 5.63579C14.2692 4.07369 16.8016 4.07397 18.3637 5.63607C19.9258 7.19816 19.9257 9.73085 18.3636 11.2929L16.9501 12.7071" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        </g>
                        </svg>
                        <div class="textWidgetLinkWindowLinkTitle">Открыть ` +
            this.getLinkView() +
            `</div>
                    </div>
                </a>
                <div class="textWidgetLinkWindowDividor"></div>
                <div class="textWidgetLinkWindowCopy">Скопировать</div>
            </div>
        `
        );
    }

    isOpened = false;

    symbolData = null;
    startData = null;
    endData = null;
    textWidget = null;

    repTimer = null;
    ghostTimer = null;
}
